var _effectorFileName = "/builds/gmini/front-common/src/Explorer/Explorer.tsx";
import "core-js/modules/es.array.some.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.concat.js";
import * as React from 'react';
import { MacosExplorer } from '@gmini/ui-kit';
import { isItemNode, isEntity, isAssembly } from "./Node";
import { Provider } from "./Provider";
import { NodeRender } from "./NodeRender";
import { buildItemKey, parentContainsChild } from "./Model";
import { TreeContextMenuProvider } from "./explorer.context";
import { DndExplorerType } from "./dnd";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var Explorer = /*#__PURE__*/React.memo(function (_ref) {
  var _ctxMenu$item;

  var data = _ref.data,
      onEntityOpen = _ref.onEntityOpen,
      onCreate = _ref.onCreate,
      onCopy = _ref.onCopy,
      onRename = _ref.onRename,
      onMove = _ref.onMove,
      onRemove = _ref.onRemove,
      entityIcon = _ref.entityIcon,
      categoryIcon = _ref.categoryIcon,
      categoryEmptyIcon = _ref.categoryEmptyIcon,
      assemblyIcon = _ref.assemblyIcon,
      activeItems = _ref.activeItems,
      setActiveItems = _ref.setActiveItems,
      fetchChildren = _ref.fetchChildren,
      pending = _ref.pending,
      panelWidth = _ref.panelWidth,
      ContextMenu = _ref.ContextMenu,
      setCtxMenu = _ref.setCtxMenu,
      ctxMenu = _ref.ctxMenu,
      hideCtxMenu = _ref.hideCtxMenu,
      selectedProject = _ref.selectedProject;
  var onMoveHandler = React.useCallback(function (rootNode, droppedNode) {
    if (isItemNode(droppedNode)) {
      onMove({
        newParentCategoryId: !rootNode || !('id' in rootNode) ? null : rootNode.id,
        type: droppedNode.type,
        id: droppedNode.id,
        version: isEntity(droppedNode) || isAssembly(droppedNode) ? droppedNode.version : null
      });
    } // GT-482 Проводник. Если в проводнике переносить дочернюю группу, раскрыв, то в третьей колонке отображается вторая колонка рутовой папки


    if (droppedNode.type === 'Category' && activeItems.some(function (key) {
      return key === buildItemKey({
        node: droppedNode
      });
    })) {
      setActiveItems(activeItems.filter(function (key) {
        return key !== buildItemKey({
          node: droppedNode
        });
      }));
    }
  }, [activeItems, onMove, setActiveItems]);
  var canDropHandler = React.useCallback(function (rootNode, droppedNode) {
    if (isItemNode(droppedNode)) {
      return !!canDrop({
        rootNode: rootNode,
        droppedNode: droppedNode,
        data: data
      });
    }

    return false;
  }, [data]);
  return /*#__PURE__*/_jsx(Provider, {
    onEntityOpen: onEntityOpen,
    onCreate: onCreate,
    onCopy: onCopy,
    onRename: onRename,
    onMove: onMove,
    onRemove: onRemove,
    categoryIcon: categoryIcon,
    categoryEmptyIcon: categoryEmptyIcon,
    entityIcon: entityIcon,
    assemblyIcon: assemblyIcon,
    selectedProject: selectedProject,
    children: /*#__PURE__*/_jsxs(TreeContextMenuProvider, {
      value: {
        onOpen: function onOpen(coords, node, onOpenCategory) {
          if (!node) {
            return;
          }

          setCtxMenu({
            coords: coords,
            item: {
              node: node,
              onOpen: onOpenCategory
            }
          });
        },
        item: ((_ctxMenu$item = ctxMenu.item) === null || _ctxMenu$item === void 0 ? void 0 : _ctxMenu$item.node) || null,
        hideCtxMenu: hideCtxMenu
      },
      children: [/*#__PURE__*/_jsx(MacosExplorer, {
        activeItems: activeItems,
        onChangeActive: setActiveItems,
        ItemRenderer: NodeRender,
        treeData: data,
        rootLoading: pending,
        onPanelContextMenu: function onPanelContextMenu(e, node) {
          e.preventDefault();

          if (!node || (node === null || node === void 0 ? void 0 : node.type) === 'Entity' || (node === null || node === void 0 ? void 0 : node.type) === 'Category') {
            setCtxMenu({
              coords: {
                x: e.clientX,
                y: e.clientY
              },
              item: {
                node: node,
                emptyPanelClick: true
              }
            });
          }
        },
        onMove: onMoveHandler,
        fetchChildren: fetchChildren,
        panelWidth: panelWidth,
        canDrop: canDropHandler,
        emptyPanelTitle: "\u041D\u0430\u0436\u043C\u0438\u0442\u0435 \u043F\u0440\u0430\u0432\u0443\u044E \u043A\u043D\u043E\u043F\u043A\u0443 \u043C\u044B\u0448\u0438",
        dndType: DndExplorerType
      }), /*#__PURE__*/_jsx(ContextMenu, {})]
    })
  });
});
Explorer.displayName = 'Explorer';
export function fromRefs(d, refs) {
  var result = [];

  function recursive(items) {
    items.forEach(function (item) {
      var _item$children;

      if (refs.includes(item.key)) {
        result.push(item);
      }

      if ((_item$children = item.children) !== null && _item$children !== void 0 && _item$children.length) {
        recursive(item.children);
      }
    });
  }

  recursive(d);
  return result;
}
export function fromNodeRefsToExplorerRefs(source) {
  return source.map(function (_ref2) {
    var id = _ref2.id,
        type = _ref2.type;
    return "".concat(type, ":").concat(id);
  });
}

function canDrop(_ref3) {
  var rootNode = _ref3.rootNode,
      droppedNode = _ref3.droppedNode,
      data = _ref3.data;

  if (rootNode && rootNode.type === droppedNode.type && rootNode.id === droppedNode.id) {
    return false;
  }

  if (rootNode && parentContainsChild({
    parent: droppedNode,
    child: rootNode
  })) {
    return false;
  }

  if (!rootNode && data.some(function (child) {
    return child.key === buildItemKey({
      node: droppedNode
    });
  })) {
    return;
  }

  if (rootNode && 'children' in rootNode && rootNode.children.some(function (child) {
    return buildItemKey({
      node: child
    }) === buildItemKey({
      node: droppedNode
    });
  })) {
    return false;
  }

  return true;
}